import React, { useState, useEffect, useContext, useMemo } from "react";
import "./team.scss";
import TeamCard from "../../components/card/teamCard";
import axios from "axios";
import { useParams } from "react-router";
import Breadcrumbs from "../../common/breadcumb";
import Loading from "../../common/loading";
import Errors from "../../common/error";
import { LangContext } from "../../context/LangContext";
function Team() {
  const lang = useContext(LangContext);
  const nep = lang.state.np;
  const { slug: initialSlug } = useParams();
  const [content, setContent] = useState(null);
  const [pageTitle, setPageTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const slug = useMemo(() => {
    let updatedSlug = initialSlug;
    switch (initialSlug) {
      case "board-of-directors":
        setPageTitle(nep ? "सञ्चालक समिति" : "Board of Directors");
        updatedSlug = "bod";
        break;
      case "management-team":
        setPageTitle(nep ? "व्यवस्थापन समुह" : "Management Team");
        updatedSlug = "management-team";
        break;
      case "head-of-department":
        setPageTitle(nep ? "विभागिय प्रमुख" : "Head of Department");
        updatedSlug = "hod";
        break;
      case "province-head":
        setPageTitle(nep ? "प्रदेश प्रमुख" : "Province Head");
        updatedSlug = "regional-head";
        break;

      default:
        setPageTitle("Team");
    }
    return updatedSlug;
  }, [initialSlug, nep]);

  const APIURL = `${process.env.REACT_APP_URL}team/all/${slug}`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await axios.get(APIURL);
        setContent(response.data.items);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [APIURL]);

  const MainData = useMemo(() => {
    if (!content) return [];
    return nep ? content.np : content.en;
  }, [content, nep]);
  // console.log("tttttttttttt", content);
  if (loading) return <Loading />;
  if (error) return <Errors />;

  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      <div className="InsidePageContainer">
        <div className="wrapper">
          <div className="team InsideFlexBox justfycenter">
            {MainData.length === 0
              ? "No Team Found."
              : MainData.map((team) => {
                  let className = "Director";
                  if (
                    team?.designation === "9" ||
                    team?.designation === "19" ||
                    team?.designation === "40"
                  ) {
                    className = "Chairman";
                  } else if (team.team_group_id === "3") {
                    className = "HOD";
                  } else if (team.team_group_id === "2") {
                    className = "MNG";
                  } else if (team.team_group_id === "4") {
                    className = "PRH";
                  } else if (team?.designation_name === "Director (Promoter)") {
                    className = "Promoter";
                  }

                  return (
                    <div className={className} key={team.id}>
                      <TeamCard team={team} nep={nep} />
                    </div>
                  );
                })}
          </div>
        </div>
      </div>
    </>
  );
}

export default Team;
